
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { 
  Search, 
  Heart, 
  Bell, 
  MessageCircle
} from "lucide-react";
import { useScrollAnimation, useStaggeredAnimation } from "@/hooks/useScrollAnimation";

const BuyerLandingFeatures = () => {
  const { ref: sectionRef, isVisible } = useScrollAnimation<HTMLElement>();
  const { ref: gridRef, visibleItems } = useStaggeredAnimation<HTMLDivElement>(4, 150);

  const features = [
    {
      icon: Search,
      title: "Smart Property Search",
      description: "Advanced filters for location, price, ARV, and property type. Find exactly what matches your investment criteria."
    },
    {
      icon: Heart,
      title: "Save & Track Properties",
      description: "Save properties to your favorites and get organized. Never lose track of potential investment opportunities."
    },
    {
      icon: Bell,
      title: "Smart Alerts",
      description: "Get instant notifications when new properties match your saved searches or from sellers you follow."
    },
    {
      icon: MessageCircle,
      title: "Direct Contact",
      description: "Connect with wholesalers and agents via email and phone. No middlemen, no delays - just direct access to deal makers."
    }
  ];

  return (
    <section ref={sectionRef} className="py-16 px-4 bg-gray-900/30">
      <div className="container mx-auto max-w-6xl">
        <h2 className={`text-3xl font-bold text-center mb-12 transition-all duration-700 ${isVisible ? 'animate-fade-in-up' : 'opacity-0 translate-y-8'}`}>
          Everything You Need to Find Your Next Deal
        </h2>
        <div ref={gridRef} className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => {
            const IconComponent = feature.icon;
            return (
              <Card 
                key={index}
                className={`bg-gray-800 border-gray-700 text-white hover-lift group transition-all duration-500 ${
                  visibleItems.includes(index) ? 'animate-scale-in' : 'opacity-0 scale-95'
                }`}
              >
                <CardHeader>
                  <IconComponent className="h-8 w-8 text-[#ffd700] mb-2 icon-bounce group-hover:animate-bounce-gentle" />
                  <CardTitle>{feature.title}</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-gray-300">
                    {feature.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default BuyerLandingFeatures;
